'use client';
import { useSuspenseQuery, useMutation } from '@apollo/client/react';
import { FC, PropsWithChildren } from 'react';
import { useCookies } from 'react-cookie';

import { GetProfileQuery } from '@/.gql/graphql';
import { GET_PROFILE, UPDATE_PROFILE_BOTNAME } from '@/.graphql';

import { createCustomContext } from './context';

const [Context, useProfileContext] = createCustomContext<
  GetProfileQuery['getProfile'] | null
>({
  name: 'ProfileContext',
  strict: false,
});
export { useProfileContext };

export const ProfileProvider: FC<PropsWithChildren> = ({ children }) => {
  const data = useSuspenseQuery(GET_PROFILE).data?.getProfile;
  const [updateProfileBotName] = useMutation(UPDATE_PROFILE_BOTNAME, {
    refetchQueries: [GET_PROFILE],
  });

  console.log('Profile data:', data);

  const [cookies] = useCookies(['_b']);

  // Бля кто так делает то, бесконечный запрос будет
  // if (cookies._b !== data?.botName) {
  //   updateProfileBotName({
  //     variables: {
  //       botName: cookies._b,
  //     },
  //   });

  //   const updatedData = {
  //     ...data,
  //     botName: cookies._b,
  //   } as Profile;

  //   return <Context value={updatedData}>{children}</Context>;
  // }

  return <Context value={data}>{children}</Context>;
};
